var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5668 3.06066C24.1525 2.47487 24.1525 1.52513 23.5668 0.93934C22.981 0.353553 22.0312 0.353553 21.4454 0.93934L12.253 10.1317L3.06066 0.939342C2.47487 0.353554 1.52513 0.353555 0.93934 0.939342C0.353554 1.52513 0.353553 2.47487 0.93934 3.06066L10.1317 12.253L0.939342 21.4454C0.353555 22.0312 0.353555 22.981 0.939342 23.5668C1.52513 24.1525 2.47487 24.1525 3.06066 23.5668L12.253 14.3744L21.4454 23.5668C22.0312 24.1525 22.981 24.1525 23.5668 23.5668C24.1525 22.981 24.1525 22.0312 23.5668 21.4454L14.3744 12.253L23.5668 3.06066Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.67d1d244ec492337990c21444b3c15dc.svg";
export { ForwardRef as ReactComponent };